import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
// import Classes from "./Classes";
import Classes from "./Classes";
import bgImage1 from "../assets/banner/bannerImg1.png";
import bgImage2 from "../assets/banner/bannerImg2.png";
import bgImage3 from "../assets/banner/bannerImg3.png";
import bgImage4 from "../assets/banner/bannerImg4.png";
import SEO from "./SEO";

export default function Banner() {
  const bgImages = [bgImage1, bgImage2, bgImage3, bgImage4];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % bgImages.length);
        setFade(true);
      }, 1000);
    }, 6000);

    return () => clearInterval(interval);
  }, [bgImages.length]);

  return (
    <>
      <SEO title="Gloves Up Boxing Gym | Best Boxing Classes in Toronto" description="Join our Toronto-based boxing gym for beginner-friendly and expert-led boxing classes. Whether you’re looking to get fit, learn techniques, or challenge yourself, we have classes for all levels." />
      <div className="bannerWrapper">
        <div
          className={`banner ${fade ? "fade-in" : "fade-out"}`}
          id="home"
          style={{
            backgroundImage: `url(${bgImages[currentImageIndex]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <h1 className="sr-only">Gloves Up Boxing Gym | Best Boxing Classes in Toronto</h1>
          <p className="sr-only">
            Gloves Up is a Toronto boxing gym offering beginner-friendly group boxing classes, kids programs, and private training. Located in the Junction and Geary neighborhood, serving all experience levels.
          </p>
        </div>
      </div>
      <div id="classes-nav">
        <Classes />
      </div>
    </>
  );
}
